import { render, staticRenderFns } from "./ModalDeleteWebhook.vue?vue&type=template&id=0b80b7a3&scoped=true"
import script from "./ModalDeleteWebhook.vue?vue&type=script&lang=js"
export * from "./ModalDeleteWebhook.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteWebhook.vue?vue&type=style&index=0&id=0b80b7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80b7a3",
  null
  
)

export default component.exports